import {SubsidiaryDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_SUBSIDIARY';

export async function createSubsidiary(
    userData: Record<string, string>,
    subsidiary: Record<string, any>
) {
    try {
        const result = await SubsidiaryDao.createSubsidiary(userData.userToken, subsidiary);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
